import React from 'react'

import TextEditor, { TEXT_EDITOR_MODES } from 'components/TextEditor/TextEditor'

import styles from './Button.module.scss'

const Button = ({ blockId, backgroundColor, borderRadius, text, onUpdateText, propName = 'buttonText' }) => (
    <div className={styles.button} style={{ backgroundColor, borderRadius }}>
        <TextEditor
            id={blockId}
            content={text}
            mode={TEXT_EDITOR_MODES.BUTTON}
            onChange={html => {
                onUpdateText({
                    [blockId]: {
                        data: { [propName]: html },
                    },
                })
            }}
        />
    </div>
)

export default Button
